module.exports = __webpack_public_path__ + "img/home-or-middle-ad.6c857530.jpg";